export const filterGroups = [
  {
    id: "category",
    title: "Category",
    isOpen: true,
    options: [
      { id: "clothing", label: "Clothing", count: 45 },
      { id: "shoes", label: "Shoes", count: 23 },
      { id: "accessories", label: "Accessories", count: 12 },
    ],
  },
  {
    id: "size",
    title: "Size",
    isOpen: true,
    options: [
      { id: "XS", label: "XS", count: 8 },
      { id: "S", label: "S", count: 15 },
      { id: "M", label: "M", count: 22 },
      { id: "L", label: "L", count: 18 },
      { id: "XL", label: "XL", count: 12 },
    ],
  },
  {
    id: "color",
    title: "Color",
    isOpen: true,
    options: [
      { id: "black", label: "Black", count: 25 },
      { id: "white", label: "White", count: 20 },
      { id: "blue", label: "Blue", count: 15 },
      { id: "red", label: "Red", count: 10 },
    ],
  },
]

export const sortOptions = [
  { value: "featured", label: "Featured" },
  { value: "newest", label: "Newest" },
  { value: "price-low-high", label: "Price: Low to High" },
  { value: "price-high-low", label: "Price: High to Low" },
  { value: "name-a-z", label: "Name: A to Z" },
  { value: "name-z-a", label: "Name: Z to A" },
]
